export const typesConfigs = [
  {
    label: 'In-country Trader',
    color: '#3282B8',
    type: 'localTrader', // same
  },
  {
    label: 'Mine Site',
    color: '#FE2D92',
    type: 'mineSite', // same
  },
  {
    label: 'Mining Operator / Cooperative',
    color: '#D36FF6',
    type: 'miningOperatorCooperative',
  },
  {
    label: 'Global Buyer',
    color: '#E3C309',
    type: 'globalBuyer',
  },
  {
    label: 'Exporter / Private LTD',
    type: 'exporterPrivateLTD',
    color: '#29A29C',
  },
  {
    label: 'Mining Operator',
    color: 'black',
    type: 'miningOperator',
  },
  {
    label: 'Exporter',
    color: '#24A19C',
    type: 'exporter',
  },
  {
    label: 'Coorporation',
    color: 'Red',
    type: 'corporation',
  },
  {
    label: 'solePriorship',
    color: 'Red',
    type: 'corporation',
  },
  {
    label: 'undetermined',
    color: 'Red',
    type: 'undetermined',
  },
];

export const defaultConfig = {
  label: 'Subject',
  color: '#3282B8',
};
